import React from "react"

function DraugiemIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.8277 14.926C32.5595 14.9993 35.904 18.4123 32.1068 23.0807C30.3642 25.2318 27.4177 27.3562 23.4868 28.7414L22.9242 28.9279C22.5538 29.0444 22.1867 29.151 21.8266 29.2609C20.9759 29.494 20.1458 29.7004 19.3431 29.8502C18.4822 30.0234 17.6521 30.1466 16.8494 30.2365C16.2766 30.2898 15.7243 30.3264 15.1892 30.3364C11.5326 30.4263 8.78165 29.4573 7.88638 27.3795C6.80587 24.8955 8.99432 21.4358 13.3746 18.8019C10.1297 20.0606 4.2504 23.0374 4 27.3029V27.8257C4.02963 28.2782 4.11603 28.7255 4.25726 29.1576C5.19027 32.0413 9.5946 33.3865 15.2029 32.9037C15.7449 32.8571 16.3006 32.7971 16.8631 32.7139C17.6761 32.5973 18.5062 32.4375 19.3568 32.2477C20.2075 32.0579 20.9999 31.8348 21.8403 31.5817C22.0221 31.5185 22.2073 31.4652 22.3925 31.4019C22.7699 31.2854 23.1403 31.1622 23.5005 31.0257C28.3542 29.3141 31.9558 27.0299 34.062 24.4226C35.2591 22.9276 35.8799 21.529 36 20.3003V19.3647C35.6536 16.2546 31.9147 14.4265 26.8277 14.926ZM23.1094 13.3843C23.2365 13.384 23.3631 13.3695 23.4868 13.341C24.2997 13.1446 24.6976 12.3021 24.7319 11.3065C24.7696 10.251 24.3889 9.37188 23.4868 9.24535C23.407 9.23685 23.3264 9.23685 23.2466 9.24535C22.9282 9.24501 22.6181 9.34425 22.3624 9.52837C22.1066 9.7125 21.9187 9.97171 21.8266 10.2676C21.6985 10.606 21.6289 10.9627 21.6208 11.3232C21.5938 11.7447 21.6641 12.1667 21.8266 12.5585C21.9251 12.8088 22.1017 13.0229 22.3317 13.171C22.5617 13.319 22.8336 13.3936 23.1094 13.3843ZM23.0923 13.7373C22.7784 13.7332 22.4652 13.7656 22.1593 13.8338L22.2348 13.9337L22.372 14.1735L22.4852 14.4265L22.5778 14.6863L22.6395 14.9527L22.6875 15.2224L22.715 15.5021V15.7685V16.0548L22.6944 16.3345V16.6109L22.6567 16.8906L22.6189 17.167L22.564 17.4467L22.5092 17.7231L22.4543 17.9928L22.3891 18.2625L22.3342 18.5222L22.2691 18.772L22.2039 19.015L22.1387 19.2481L22.0838 19.4712L22.0289 19.6843L22.0015 19.8208L21.9638 19.9707L21.9295 20.1338L21.8986 20.3037L21.8643 20.4835L21.8369 20.6366V20.6699L21.7991 20.8697L21.7614 21.0662L21.7339 21.2726L21.6859 21.4991L21.6585 21.7155L21.6208 21.9286L21.5933 22.155L21.559 22.3681L21.5281 22.5946L21.5007 22.8177L21.4733 23.0408C21.5281 23.6868 21.5762 24.2328 21.6036 24.5458C21.6072 24.8231 21.684 25.0948 21.8266 25.335C21.9283 25.4616 22.06 25.5625 22.2105 25.6291C22.361 25.6958 22.5258 25.7262 22.691 25.7179C22.9811 25.7173 23.2621 25.6197 23.4868 25.4416C23.7069 25.1898 23.8369 24.8755 23.8572 24.5458C24.0047 23.6235 24.4301 20.5934 24.7971 19.2947C25.3253 17.4234 26.5876 14.017 23.4868 13.7572C23.3559 13.7422 23.2241 13.7355 23.0923 13.7373ZM19.3191 12.775H19.3397C20.5403 12.775 21.1028 11.7028 21.1028 10.3941C21.1028 9.08552 20.5437 8.00999 19.3431 8H19.3191C18.1014 8 17.5389 9.07553 17.5389 10.3941C17.5389 11.7127 18.1048 12.775 19.3191 12.775ZM16.8494 18.3058C16.9592 18.762 17.0724 19.1848 17.165 19.5611C17.5423 21.0562 17.9127 24.5325 18.05 25.5814C18.1872 26.6303 18.5679 26.8634 19.3431 26.9333C20.108 26.8634 20.4957 26.6403 20.626 25.5814C20.7564 24.5225 21.1337 21.0562 21.5007 19.5611C21.5933 19.1848 21.7134 18.762 21.8437 18.3058C22.1867 16.9339 22.4611 15.3089 21.8437 14.2834C21.4458 13.6174 20.6877 13.1779 19.3603 13.1779C18.0328 13.1779 17.2542 13.6174 16.8665 14.2834C16.232 15.3223 16.5064 16.9339 16.8494 18.3058ZM15.2029 13.341C15.3266 13.3695 15.4532 13.384 15.5802 13.3843C15.8558 13.3896 16.1262 13.3113 16.3537 13.1602C16.5812 13.0092 16.7545 12.7931 16.8494 12.5419C17.0023 12.1476 17.0712 11.7273 17.0518 11.3065C17.0413 10.9466 16.973 10.5904 16.8494 10.251C16.7553 9.95617 16.567 9.69814 16.3116 9.51432C16.0563 9.3305 15.7472 9.23046 15.4293 9.2287C15.3495 9.21996 15.269 9.21996 15.1892 9.2287C14.2939 9.35523 13.9063 10.2276 13.9406 11.2899C13.9681 12.3021 14.3762 13.1446 15.2029 13.341ZM14.8187 24.5425C14.838 24.8748 14.9735 25.1908 15.2029 25.4382C15.4265 25.6159 15.7063 25.7135 15.9953 25.7146C16.161 25.7235 16.3265 25.6933 16.4776 25.6266C16.6287 25.5599 16.761 25.4587 16.8631 25.3317C16.9963 25.0877 17.0724 24.8183 17.0861 24.5425C17.1135 24.2295 17.1581 23.6834 17.213 23.0474V23.0275L17.1855 22.8044L17.1581 22.5813L17.1204 22.3548L17.0929 22.1417L17.0655 21.9153L17.0312 21.7022L16.9866 21.4991L16.9523 21.286L16.918 21.0662L16.8906 20.8697L16.8528 20.6699V20.6433L16.822 20.5001L16.7842 20.3203L16.7465 20.1505L16.719 19.9873L16.6847 19.8375L16.647 19.701L16.599 19.4879L16.5338 19.2648L16.4789 19.0317L16.4172 18.7886L16.352 18.5389L16.2868 18.2791L16.232 17.9928L16.1668 17.7231L16.1119 17.4467L16.0639 17.1703L16.0296 16.8939L15.9919 16.6142L15.9644 16.3379V16.0515V15.7718V15.5054L15.9919 15.2257L16.0364 14.956L16.1016 14.6896L16.1839 14.4299L16.304 14.1768L16.4446 13.9371L16.5167 13.8372C16.2107 13.7693 15.8975 13.7369 15.5837 13.7406C15.4523 13.7321 15.3205 13.7321 15.1892 13.7406C12.102 14.0003 13.3506 17.4034 13.8789 19.2781C14.2459 20.59 14.6712 23.6202 14.8187 24.5425Z"
        fill="currentColor"
      />
    </svg>
  )
}

function FacebookIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.8889 10H11.1111C10.8164 10 10.5338 10.1171 10.3254 10.3254C10.1171 10.5338 10 10.8164 10 11.1111V28.8889C10 29.1836 10.1171 29.4662 10.3254 29.6746C10.5338 29.8829 10.8164 30 11.1111 30H20.6833V22.2667H18.0861V19.2389H20.6833V17.0167C20.6833 14.4333 22.2611 13.025 24.5722 13.025C25.3497 13.0227 26.1268 13.0626 26.9 13.1444V15.8333H25.3056C24.0528 15.8333 23.8083 16.4306 23.8083 17.3056V19.2333H26.8056L26.4167 22.2611H23.8083V30H28.8889C29.1836 30 29.4662 29.8829 29.6746 29.6746C29.8829 29.4662 30 29.1836 30 28.8889V11.1111C30 10.8164 29.8829 10.5338 29.6746 10.3254C29.4662 10.1171 29.1836 10 28.8889 10V10Z"
        fill="currentColor"
      />
    </svg>
  )
}

function InstagramIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.0179 30.2043C26.3824 30.2043 27.6703 29.6821 28.6444 28.734C29.6185 27.7859 30.155 26.5323 30.155 25.2043V14.7957C30.155 13.4677 29.6185 12.2141 28.6444 11.266C27.6703 10.3179 26.3824 9.79571 25.0179 9.79571H14.9821C13.6176 9.79571 12.3297 10.3179 11.3556 11.266C10.3814 12.2141 9.84495 13.4677 9.84495 14.7957V25.2043C9.84495 26.5323 10.3814 27.7859 11.3556 28.734C12.3297 29.6821 13.6176 30.2043 14.9821 30.2043H25.0179ZM25.0179 32H14.9821C11.1419 32 8 28.9419 8 25.2043V14.7957C8 11.0581 11.1419 8 14.9821 8H25.0179C28.8581 8 32 11.0581 32 14.7957V25.2043C32 28.9419 28.8581 32 25.0179 32Z"
        fill="currentColor"
      />
      <path
        d="M20.0053 15.7004C17.6152 15.7004 15.6777 17.5862 15.6777 19.9124C15.6777 22.2387 17.6152 24.1245 20.0053 24.1245C22.3953 24.1245 24.3328 22.2387 24.3328 19.9124C24.3328 17.5862 22.3953 15.7004 20.0053 15.7004ZM26.6459 19.9074C26.6459 23.4599 23.687 26.3398 20.0371 26.3398C16.3871 26.3398 13.4282 23.4599 13.4282 19.9074C13.4282 16.3548 16.3871 13.4749 20.0371 13.4749C23.687 13.4749 26.6459 16.3548 26.6459 19.9074Z"
        fill="currentColor"
      />
      <path
        d="M28.3169 13.3748C28.3169 14.216 27.6163 14.898 26.752 14.898C25.8878 14.898 25.1872 14.216 25.1872 13.3748C25.1872 12.5337 25.8878 11.8517 26.752 11.8517C27.6163 11.8517 28.3169 12.5337 28.3169 13.3748Z"
        fill="currentColor"
      />
    </svg>
  )
}

function LinkedInIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.5 10H11.5C10.7 10 10 10.603 10 11.407V28.593C10 29.397 10.7 30 11.5 30H28.5C29.3 30 30 29.397 30 28.593V11.407C30 10.7035 29.3 10 28.5 10ZM15.9 27.1859H12.9V17.6382H15.9V27.1859ZM14.4 16.2311C13.4 16.2311 12.7 15.4272 12.7 14.5226C12.7 13.6181 13.5 12.8141 14.4 12.8141C15.3 12.8141 16.1 13.6181 16.1 14.5226C16.2 15.5277 15.4 16.2311 14.4 16.2311ZM27 27.1859H24V22.5628C24 21.4573 24 20.0503 22.5 20.0503C21 20.0503 20.7 21.2563 20.7 22.5628V27.2864H17.7V17.7387H20.5V19.0453C20.9 18.2412 21.9 17.5377 23.3 17.5377C26.3 17.5377 26.9 19.5478 26.9 22.0603V27.1859H27Z"
        fill="currentColor"
      />
    </svg>
  )
}

function TwitterIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 12.39C33.069 12.7673 32.0049 13.0189 30.8079 13.1447C31.8719 12.5157 32.803 11.5094 33.202 10.3773C32.1379 11.0063 30.9409 11.3836 29.7438 11.6352C28.8128 10.6289 27.3498 10 25.7537 10C22.6946 10 20.3005 12.2642 20.3005 15.0314C20.3005 15.4088 20.3005 15.7862 20.4335 16.1636C15.9113 15.912 11.9212 13.8994 9.12808 10.8805C8.59606 11.6352 8.33005 12.5157 8.33005 13.3962C8.33005 15.1572 9.26108 16.6666 10.7241 17.6729C9.7931 17.6729 8.99507 17.4214 8.19704 17.044C8.19704 17.044 8.19704 17.044 8.19704 17.1698C8.19704 19.6855 10.0591 21.6981 12.5862 22.2013C12.1872 22.3271 11.6552 22.327 11.1232 22.327C10.7241 22.327 10.4581 22.3271 10.0591 22.2013C10.7241 24.2139 12.7192 25.7233 15.1133 25.7233C13.2512 27.1069 10.8571 27.8617 8.33005 27.8617C7.93104 27.8617 7.39902 27.8616 7 27.7358C9.39409 29.2453 12.3202 30 15.3793 30C25.3547 30 30.9409 22.2013 30.9409 15.5346C30.9409 15.283 30.9409 15.0315 30.9409 14.9057C32.4039 14.2768 33.335 13.3963 34 12.39Z"
        fill="currentColor"
      />
    </svg>
  )
}

function YouTubeIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.4701 13.8186C32.1848 12.7163 31.3288 11.8372 30.2554 11.5442C28.3125 11 20.5 11 20.5 11C20.5 11 12.6739 11.014 10.731 11.5581C9.65761 11.8512 8.80163 12.7302 8.5163 13.8326C8 15.8279 8 20 8 20C8 20 8 24.1721 8.52989 26.1814C8.81522 27.2837 9.6712 28.1628 10.7446 28.4558C12.6875 29 20.5 29 20.5 29C20.5 29 28.3125 29 30.2554 28.4558C31.3288 28.1628 32.1848 27.2837 32.4701 26.1814C33 24.186 33 20 33 20C33 20 33 15.8279 32.4701 13.8186ZM18 23.8512V16.1488L24.4946 20L18 23.8512Z"
        fill="currentColor"
      />
    </svg>
  )
}

function getSiteIconByType(type) {
  switch (type) {
    case "draugiem":
      return <DraugiemIcon />
    case "facebook":
      return <FacebookIcon />
    case "instagram":
      return <InstagramIcon />
    case "linkedin":
      return <LinkedInIcon />
    case "twitter":
      return <TwitterIcon />
    case "youtube":
      return <YouTubeIcon />
    default:
      return null
  }
}

export default function SocialIcon({ type, className, style }) {
  return (
    <i className={className} style={style}>
      {getSiteIconByType(type)}
    </i>
  )
}
